/* eslint-disable object-curly-spacing */ 
/* eslint-disable no-undef */ 
/* eslint-disable own-handles */ 
/* eslint-disable no-innerhtml-assign */ 
/* eslint-disable consistent-method-names */ 
/* eslint-disable no-jsdoc */ 
define(['./locale'], function(Locale) {
    'use strict';
    return function(languageCode, serviceType) {
        var locale = new Locale(languageCode);
        return locale.getValueFor(serviceType) === languageCode;
    };
});



// WEBPACK FOOTER //
// ./config/language/validator.js